import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { buildDetailPath, buildShortDetailPath, parseLegacyCombinedSlug } from '../../utils/shared/slugify';

function LegacyDetailRedirect({ basePath, suffix }) {
  const { slug, campaignId } = useParams();
  const { nameSlug, id } = parseLegacyCombinedSlug(slug);

  if (!id) return <Navigate to={basePath} replace />;

  const resolvedSuffix = typeof suffix === 'function' ? suffix({ campaignId }) : suffix;
  const to = nameSlug
    ? buildDetailPath(basePath, nameSlug, id, resolvedSuffix)
    : buildShortDetailPath(basePath, id, resolvedSuffix);

  return <Navigate to={to} replace />;
}

export default LegacyDetailRedirect;
